export default "__VITE_ASSET__D$rAZyli__"